import { cn } from '@/lib/utils';
import mark from '@/config/brand-mark.json';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showGradient?: boolean;
  animated?: boolean;
}

/** Shared geometry with the generated favicon and standalone brand assets. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox={mark.viewBox} fill="none" aria-hidden="true" className={className}>
      <path d={mark.orbit} stroke="currentColor" strokeWidth={mark.strokeWidth} strokeLinecap="round" />
      <path d={mark.arrow} stroke="currentColor" strokeWidth={mark.strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d={mark.play} fill="currentColor" />
    </svg>
  );
}

export function Logo({ size = 'md', className }: LogoProps) {
  const sizes = { sm: 'text-lg gap-2', md: 'text-[23px] gap-2.5', lg: 'text-4xl gap-3', xl: 'text-6xl gap-4' };
  const icons = { sm: 'w-7 h-7', md: 'w-9 h-9', lg: 'w-12 h-12', xl: 'w-16 h-16' };
  return (
    <span className={cn('inline-flex items-center font-bold leading-none tracking-[-0.05em] text-white', sizes[size], className)}>
      <BrandMark className={cn('shrink-0 text-cyan-300', icons[size])} />
      <span>ballcam<span className="font-medium text-cyan-300">.tv</span></span>
    </span>
  );
}
